import _ from "lodash";

export default t => (password, schema) => schema.test(
  "samePasswords", t("passwords_dont_match"), repeatPassword => _.isEqual(password, repeatPassword),
);
